export const depictMerchant = process.env.DEPICT_MERCHANT || "poc"
